import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import ProgressBackdrop from '@/components/ProgressBackdrop';

import Alert from '@/components/Alert';
import preOrderAPI from '../../../preorder/api/preOrder';

const Page = styled.div`
  min-height: 100vh;
`;

const TapPay3DPayment = () => {
  const history = useHistory();
  const { search } = useLocation();
  const [alert, setAlert] = React.useState(undefined);
  const queryParams = queryString.parse(search);

  React.useEffect(() => {
    if (queryParams.cancel) {
      setAlert({
        title: '交易取消',
        message: '交易已被取消，請重新再試一次',
      });
      return;
    }
    if (!queryParams.requestId || !queryParams.submitTapPay3D) return;
    const checkFunction = async (retry = 0) => {
      const confirmResult = await preOrderAPI.confirmTapPay3DRequestInfo({
        body: {
          requestId: queryParams.requestId,
        },
      });
      const {
        orderId,
        status,
        totalPrice,
        items,
      } = confirmResult || {};
      if (status !== 'OK') {
        if (retry === 10) {
          setAlert({
            title: '交易失敗',
            message: '交易失敗，請重新再試一次',
          });
          return;
        }
        setTimeout(() => checkFunction(retry + 1), 5000);
        return;
      }
      history.replace('/ec/checkout/receipt', {
        orderId,
        totalPrice,
        items,
        urlToGo: '/',
      });
    };
    checkFunction(0);

  }, []); // eslint-disable-line 

  const handleGoBack = React.useCallback(() => {
    setAlert(null);
    history.replace('/');
  }, [history, setAlert]);

  return (
    <Page>
      {
        alert ? (
          <Alert
            isOpen
            title={alert?.title || ''}
            content={alert?.message || ''}
            buttons={alert?.buttons || (
              <Button fullWidth onClick={handleGoBack}>
                <Box fontWeight="fontWeightBold" color="support.main">
                  確認
                </Box>
              </Button>
            )}
          />
        ) : <ProgressBackdrop isShow />
      }
    </Page>
  );
};

export default TapPay3DPayment;
